import { useState, useEffect } from 'react'
import { PageHeader, StatusBadge } from '../components/UI'
import { get } from '../utils/api'
import { formatDate, formatCurrency, statusColor } from '../utils/helpers'
import { IconPrinter, IconMail } from '@tabler/icons-react'

export default function GroupResumePage() {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    get('/events', { include_spaces: 'true' })
      .then(data => {
        const today = new Date().toISOString().split('T')[0]
        setEvents(data.filter(e => e.departure_date >= today).sort((a, b) => a.arrival_date.localeCompare(b.arrival_date)))
      }).catch(() => setEvents([])).finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary" /></div>

  return (
    <>
      <PageHeader title="Group Resume" subtitle="In-house and upcoming group information for operations"
        actions={<button className="btn btn-outline-secondary btn-sm" onClick={() => window.print()}><IconPrinter size={16} className="me-1" />Print All</button>} />

      {events.length === 0 ? <div className="text-center py-5 text-secondary">No upcoming groups</div> : (
        <div className="row row-cards">
          {events.map(ev => (
            <div key={ev.id} className="col-12">
              <div className="card">
                <div className="card-header bg-primary text-white">
                  <div className="d-flex justify-content-between align-items-start w-100">
                    <div>
                      <h3 className="card-title text-white mb-0">{ev.event_name}</h3>
                      <div style={{ fontSize: '0.85rem', opacity: 0.85 }}>{ev.company} — {ev.event_type}</div>
                    </div>
                    <div className="d-flex gap-1 d-print-none">
                      <button className="btn btn-icon btn-sm" style={{ background: 'rgba(255,255,255,0.15)' }}><IconPrinter size={16} className="text-white" /></button>
                      <button className="btn btn-icon btn-sm" style={{ background: 'rgba(255,255,255,0.15)' }}><IconMail size={16} className="text-white" /></button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="datagrid mb-3">
                    <div className="datagrid-item"><div className="datagrid-title">Arrival</div><div className="datagrid-content">{formatDate(ev.arrival_date, { weekday: 'short', month: 'short', day: 'numeric' })}</div></div>
                    <div className="datagrid-item"><div className="datagrid-title">Departure</div><div className="datagrid-content">{formatDate(ev.departure_date, { weekday: 'short', month: 'short', day: 'numeric' })}</div></div>
                    <div className="datagrid-item"><div className="datagrid-title">Room Block</div><div className="datagrid-content">{ev.room_count} rooms</div></div>
                    <div className="datagrid-item"><div className="datagrid-title">Rate</div><div className="datagrid-content">{formatCurrency(ev.rate)}/night</div></div>
                    <div className="datagrid-item"><div className="datagrid-title">Contact</div><div className="datagrid-content">{ev.contact_name}</div></div>
                    <div className="datagrid-item"><div className="datagrid-title">Status</div><div className="datagrid-content"><StatusBadge status={ev.status} /></div></div>
                  </div>

                  {(ev.meeting_rooms || []).length > 0 && (
                    <div className="mb-3">
                      <div className="subheader mb-1">Meeting Spaces</div>
                      <div className="d-flex flex-wrap gap-1">{ev.meeting_rooms.map(r => <span key={r} className="badge bg-blue-lt">{r}</span>)}</div>
                    </div>
                  )}

                  <div className="row g-3 mb-3">
                    <div className="col-4 text-center"><div className="subheader">Room Revenue</div><div className="fw-bold">{formatCurrency(ev.room_count * ev.rate * (ev.room_nights / (ev.room_count || 1)))}</div></div>
                    <div className="col-4 text-center"><div className="subheader">F&B</div><div className="fw-bold">{formatCurrency(ev.food_bev_revenue)}</div></div>
                    <div className="col-4 text-center"><div className="subheader">AV</div><div className="fw-bold">{formatCurrency(ev.av_revenue)}</div></div>
                  </div>

                  {ev.notes && (
                    <div className="alert alert-warning mb-0">
                      <strong>Special Notes:</strong> {ev.notes}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
